import http from '@/services/http'
import { pickBy, identity } from 'lodash'
import { sleep } from '@/utils'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    reactions: [],
    page: null,
    totalCount: null,

    sendInviteInProgress: false,
  },
  mutations: {
    startedFetch(state) {
      state.fetchInProgress = true
    },
    stoppedFetch(state) {
      state.fetchInProgress = false
    },
    setListData(state, { reactions, count }) {
      state.reactions = reactions
      state.totalCount = count
    },
    startSendInvite(state) {
      state.sendInviteInProgress = true
    },
    stopSendInvite(state) {
      state.sendInviteInProgress = false
    },
  },
  actions: {
    async fetch({ commit }, opts) {
      opts = opts || {}
      let params = { page: 1, ...opts }
      params = pickBy(params, identity)
      commit('startedFetch')
      const response = await http.getAuthed('/reactions', params)
      commit('setListData', {
        reactions: response.data.results,
        count: response.data.count,
      })
      commit('stoppedFetch')
    },
    async sendInvites(
      { commit },
      { investorId, startups, emails, messageTemplate },
    ) {
      commit('startSendInvite')
      try {
        const url = `/investors/${investorId}/invite-to-startups`
        await sleep(2000)
        await http.postAuthed(url, {
          startups,
          emails,
          message_template: messageTemplate,
        })
      } finally {
        commit('stopSendInvite')
      }
    },
  },
}
